"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverTimestamp = void 0;
var firestore_1 = require("firebase/firestore");
/**
Returns a sentinel used with @firebase/firestore/lite#(setDoc:1) or @firebase/firestore/lite#(updateDoc:1) to include a server-generated timestamp in the written data.
 */
var serverTimestamp = function () {
    return (0, firestore_1.serverTimestamp)();
};
exports.serverTimestamp = serverTimestamp;
